import {
  beMessGetBeeTemplateDetails,
  beMessGetBeeCentralizedEmailTemplateDetails,
  beMessApiGetHtmlFromIdTemplate,
  beMessGetTemplateDetails,
  beMessGetCentralizedEmailTemplateDetails,
  beMessGetBeeCentralizedNotificationConfirmationTemplateDetails,
  beMessGetBeeCentralizedWelcomeTemplateDetails
} from 'Api/BeMessApi'

import { storeGet } from 'Helpers/localStorage'
import { STORE_KEY_ACCOUNT, STORE_KEY_ID_LIST, STORE_KEY_LIST } from 'Constants'

import { toLocalDate, dateFormat } from 'Helpers/dates'

import { replaceContentForPreview } from 'Helpers/preview'
import { getLang } from 'mailup-react-helpers'

const getSendingDate = lang => {
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const now = toLocalDate(new Date(), TimeZoneCode)
  return {
    Day: now.getDate(),
    DayName: dateFormat(now, lang, 'dddd'),
    Month: now.getMonth() + 1,
    MonthName: dateFormat(now, lang, 'MMMM'),
    Year: now.getFullYear()
  }
}

export async function getTemplateDetails(
  id,
  local,
  kind = 'bee',
  msgtype = 'email'
) {
  const centralDetailsApi =
    msgtype === 'confirmation'
      ? beMessGetBeeCentralizedNotificationConfirmationTemplateDetails
      : msgtype === 'welcome'
      ? beMessGetBeeCentralizedWelcomeTemplateDetails
      : beMessGetBeeCentralizedEmailTemplateDetails

  const calls =
    kind === 'bee'
      ? [
          local === 'Centralized'
            ? centralDetailsApi(id)
            : beMessGetBeeTemplateDetails(id),
          beMessApiGetHtmlFromIdTemplate(id, local)
        ]
      : [
          local === 'Centralized'
            ? beMessGetCentralizedEmailTemplateDetails(id)
            : beMessGetTemplateDetails(id)
        ]

  const [details, contents] = await Promise.all(calls)

  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const { MandatorySender } = storeGet(STORE_KEY_LIST)
  const sendingDate = getSendingDate(getLang())

  const Contents = replaceContentForPreview(
    kind === 'bee' ? contents : details.Content,
    idList,
    Domain,
    MandatorySender,
    sendingDate
  )

  return {
    Title: details.Title,
    Contents
  }
}
